// Private, weakly held reset callbacks. No config data or browser-global registry.
export const testResets = new WeakMap<object, () => void>();
